import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Translations from './translations';

i18n.use(initReactI18next).init({
  fallbackLng: 'en-US',
  lng: localStorage.getItem('language')!,
  resources: Translations,
  keySeparator: false,
  interpolation: {
    escapeValue: false,
  },
  debug: true,
  parseMissingKeyHandler: () => undefined,
});

export default i18n;
